<script>
  import PlaylistItemPlayed from "./PlaylistItemPlayed.svelte";
  import PlaylistItemActive from "./PlaylistItemActive.svelte";
  import PlaylistItemUnplayed from "./PlaylistItemUnplayed.svelte";

  export let video
  export let played = false;
  export let active
  export let last = false;
</script>

{#if played}
  <PlaylistItemPlayed video={video} last={last} on:video-clicked/>
{:else if active}
  <PlaylistItemActive video={video} last={last} on:video-clicked/>
{:else}
  <PlaylistItemUnplayed video={video} last={last} on:video-clicked />
{/if}

